import { render, staticRenderFns } from "./Ingredients.vue?vue&type=template&id=090d05a3&scoped=true"
import script from "./Ingredients.vue?vue&type=script&lang=js"
export * from "./Ingredients.vue?vue&type=script&lang=js"
import style0 from "./Ingredients.vue?vue&type=style&index=0&id=090d05a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090d05a3",
  null
  
)

export default component.exports